import { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import IconButton from 'components/ui/IconButton';
import { faPlus, faTrash } from '@fortawesome/pro-light-svg-icons';
import ActionButton from 'components/ui/ActionButton';

type AddActionCellProps = {
    mode: 'add';
    onAdd: () => void;
    disabled?: boolean;
    rowIndex: number;
    colIndex: number;
    cellInputRefs?: MutableRefObject<{
        [key: string]: unknown;
    }>;
    handleArrowKeyDown?: (e: React.KeyboardEvent, itemId: any, rowIndex: any, colIndex: any) => void;
    onAddComplete?: () => void;
};

type RemoveActionCellProps = {
    mode: 'remove';
    onRemove: () => void;
    disabled?: boolean;
    rowIndex: number;
    colIndex: number;
    cellInputRefs?: MutableRefObject<{
        [key: string]: unknown;
    }>;
    handleArrowKeyDown?: (e: React.KeyboardEvent, itemId: any, rowIndex: any, colIndex: any) => void;
    onRemoveComplete?: () => void;
};

type ActionCellProps = AddActionCellProps | RemoveActionCellProps;

const ActionCell = (props: ActionCellProps) => {
    const { t } = useTranslation();

    if (props.mode === 'add') {
        const handleKeyDown = (e: React.KeyboardEvent) => {
            if (e.key === 'Enter' && !props.disabled) {
                e.preventDefault();
                e.stopPropagation();
                props.onAdd();
                // Focus back to the select cell (column 0) after adding
                props.onAddComplete?.();
                return;
            }
            props.handleArrowKeyDown?.(e, 'additionalCosts', props.rowIndex, props.colIndex);
        };

        return (
            <ActionButton
                icon={faPlus}
                label={t('addCost')}
                onClick={props.onAdd}
                disabled={props.disabled}
                title={t('addCost')}
                fullWidth
                main
                rounded
                onKeyDown={handleKeyDown}
            />
        );
    }

    const handleRemoveKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !props.disabled) {
            e.preventDefault();
            e.stopPropagation();
            props.onRemove();
            props.onRemoveComplete?.();
            return;
        }
        props.handleArrowKeyDown?.(e, 'additionalCosts', props.rowIndex, props.colIndex);
    };

    return (
        <ActionButton
            label={t('removeCost')}
            onClick={props.onRemove}
            disabled={props.disabled}
            title={t('removeCost')}
            icon={faTrash}
            fullWidth
            main
            rounded
            onKeyDown={handleRemoveKeyDown}
        />
    );
};

export default ActionCell;
